import React from 'react';
import {
  Phone, Clock, MessageSquare, MessageCircle, Sparkles, Wrench, Leaf,
  ClipboardCheck, Wind, CircleCheck, PlayCircle, ChevronRight, ChevronLeft,
  Home, MapPin, Zap, Target, Gem, Gift, Calendar, Navigation, Car,
  Check, MailCheck, Plus, Droplets, SprayCan, Brush, Shield, Star, CircleDashed,
  Motorbike, Caravan, Van, BookOpen,
} from 'lucide-react';
import { SteamExterior, Interior, FullPackage, Seat } from './ServiceIcons';

// Vehicle category icons for booking step 0 — sourced from lucide-react (verified modern designs)
export const VehicleCar = Car;
export const VehicleMotorcycle = Motorbike;

// Vehicle-type-level icons rendered per vehicle card (sedan/SUV/van/motorcycle)
const VEHICLE_TYPE_ICON_MAP = { Car, Caravan, Van, Motorbike };

export function VehicleTypeIcon({ icon, size = 32, strokeWidth = 1.8, ...rest }) {
  const Cmp = VEHICLE_TYPE_ICON_MAP[icon];
  if (!Cmp) return null;
  return <Cmp size={size} strokeWidth={strokeWidth} {...rest} />;
}

const LUCIDE_MAP = {
  Phone, Clock, MessageSquare, MessageCircle, Sparkles, Wrench, Leaf,
  ClipboardCheck, Wind, CircleCheck, PlayCircle, ChevronRight, ChevronLeft,
  Home, MapPin, Zap, Target, Gem, Gift, Calendar, Navigation, Car,
  Check, MailCheck, Plus, Droplets, SprayCan, Brush, Shield, Star, CircleDashed,
  Motorbike, Caravan, Van, BookOpen,
};

export const SERVICE_ICONS = {
  'steam-exterior': SteamExterior,
  'interior': Interior,
  'full-package': FullPackage,
  'seat-cleaning': Seat,
};

export function ServiceIcon({ serviceId, fallbackIcon, size = 40, strokeWidth = 1.5, ...rest }) {
  const Cmp = SERVICE_ICONS[serviceId];
  if (Cmp) return <Cmp size={size} strokeWidth={strokeWidth} {...rest} />;
  // Fallback for new services: use lucide icon by name (fallbackIcon field)
  if (fallbackIcon && LUCIDE_MAP[fallbackIcon]) {
    const FallbackCmp = LUCIDE_MAP[fallbackIcon];
    return <FallbackCmp size={size} strokeWidth={strokeWidth} {...rest} />;
  }
  return null;
}

export function Icon({ name, size = 24, strokeWidth = 1.5, ...rest }) {
  const Cmp = LUCIDE_MAP[name];
  if (!Cmp) {
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.warn(`[Icon] Unknown or unregistered icon: "${name}". Add it to LUCIDE_MAP in icons/index.js`);
    }
    return null;
  }
  return <Cmp size={size} strokeWidth={strokeWidth} {...rest} />;
}

export { SteamExterior, Interior, FullPackage, Seat };
